export default "__VITE_ASSET__CnfweaaE__"